import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getCookieConsent } from './CookieConsent';
import { initAnalyticsIfConsented, trackPageView } from '../services/AnalyticsService';

/**
 * Mounted once inside BrowserRouter (see App.tsx). Renders nothing -- it
 * only (a) boots GA/Clarity on load if consent was already granted in an
 * earlier session, and (b) sends a page_view on every client-side route
 * change, since react-router never triggers a real page load for gtag's
 * own automatic pageview to pick up.
 */
const Analytics: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    initAnalyticsIfConsented(getCookieConsent()?.analytics ?? false);
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default Analytics;
